
export const EDIT_TO_MODERATOR_LABEL = "Информация для модератора"

export const REVIEW_TO_MODERATOR_LABEL = "Информация для мододела"

export const EDIT_TO_MODERATOR_LABEL_TEXT = "Не более 1 000 символов"
